/* Bennett & Cross : fiche produit v2
   1. Description en onglets depliants (Details, Specifications, Shipping & returns, Care)
   2. Bandeau « The details » alimente par la fiche technique
   3. Pierres de couleur sur l'option « Birth Month » */
(function () {
  if (!getComputedStyle(document.documentElement).getPropertyValue('--bc-pdp-v2')) {
    window.addEventListener('load', function () { setTimeout(run, 50); }, { once: true });
    return;
  }
  run();

  function run() {
    if (window.__bcPdpV2) return;
    window.__bcPdpV2 = true;
    var desc = document.querySelector('.product__description .bc-product');
    var specsRows = [];
    if (desc) specsRows = buildAccordions(desc);
    buildBand(specsRows);
    birthstones();
    bindCombo();
    hideEmptyReviews(); setTimeout(hideEmptyReviews, 2500); setTimeout(hideEmptyReviews, 6000);
    document.addEventListener('change', function (e) { if (e.target && e.target.closest('variant-selects, variant-radios')) setTimeout(birthstones, 60); });
  }

  function acc(title, bodyNode, open) {
    var d = document.createElement('details');
    d.className = 'bc-acc';
    if (open) d.open = true;
    var s = document.createElement('summary');
    s.textContent = title;
    d.appendChild(s);
    var b = document.createElement('div');
    b.className = 'bc-acc__body';
    b.appendChild(bodyNode);
    d.appendChild(b);
    return d;
  }

  function buildAccordions(root) {
    var details = root.querySelector(':scope > details');
    if (!details) return [];
    var inner = details.querySelector(':scope > div') || details;
    var sections = inner.querySelectorAll(':scope > section');
    var feats = null, specs = null, care = null, rows = [];
    sections.forEach(function (sec) {
      var h = sec.querySelector('h4');
      var t = h ? h.textContent.trim().toLowerCase() : '';
      if (!h) feats = sec;
      else if (t.indexOf('specification') === 0) specs = sec;
      else if (t.indexOf('care') === 0) care = sec;
    });
    var wrap = document.createElement('div');
    wrap.className = 'bc-accs';
    if (feats) wrap.appendChild(acc('Details', feats, false));
    if (specs) {
      var h = specs.querySelector('h4'); if (h) h.remove();
      specs.querySelectorAll(':scope > div').forEach(function (r) {
        var sp = r.querySelectorAll('span');
        if (sp.length >= 2) rows.push([sp[0].textContent.trim(), sp[1].textContent.trim()]);
      });
      wrap.appendChild(acc('Specifications', specs, false));
    }
    var ship = document.createElement('div');
    ship.innerHTML = '<p>Free worldwide shipping on every order. Your piece ships within 1 business day, with tracking. You receive a tracking number by email.</p>' +
      '<p>Not the right fit? You have 30 days to return it. Every piece is covered by a 1-year warranty on its finish and clasp.</p>' +
      '<p><a href="/policies/refund-policy">Returns policy</a> · <a href="/policies/shipping-policy">Shipping policy</a></p>';
    wrap.appendChild(acc('Shipping & returns', ship, false));
    if (care) { var hc = care.querySelector('h4'); if (hc) hc.remove(); wrap.appendChild(acc('Care', care, false)); }
    details.replaceWith(wrap);
    return rows;
  }

  function buildBand(rows) {
    var band = document.querySelector('[data-bc-band]');
    if (!band) return;
    var dl = band.querySelector('[data-bc-band-specs]');
    rows.filter(function (r) { return !/^shipping$/i.test(r[0]); }).slice(0, 7).forEach(function (r) {
      var dt = document.createElement('dt'); dt.textContent = r[0];
      var dd = document.createElement('dd'); dd.textContent = r[1];
      dl.appendChild(dt); dl.appendChild(dd);
    });
    if (dl.children.length) band.hidden = false;
  }

  var MONTH = { january: '#8E1B2E', february: '#7A4BA8', march: '#8FC6E0', april: '#EEF1F5', may: '#1F8A4C', june: '#C9A7DA',
    july: '#C21E36', august: '#9BC53D', september: '#1F3F9E', october: '#F2A7BE', november: '#F2C12E', december: '#3FA3D6' };

  function birthstones() {
    document.querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
      var lg = fs.querySelector('legend');
      if (!lg || !/birth month/i.test(lg.textContent)) return;
      fs.classList.add('bc-months');
    });
  }

  /* 4. Combinaison inexistante (ex. Rose Gold + un style absent) : on bascule sur une combinaison qui existe */
  var bcVariants = null;
  function loadVariants() {
    if (bcVariants) return Promise.resolve(bcVariants);
    var path = location.pathname.replace(/\/$/, '');
    return fetch(path + '.js').then(function (r) { return r.json(); }).then(function (p) { bcVariants = p.variants || []; return bcVariants; }).catch(function () { return []; });
  }
  function fieldsets() { return Array.prototype.slice.call(document.querySelectorAll('variant-selects fieldset, variant-radios fieldset')); }
  function current() { return fieldsets().map(function (fs) { var i = fs.querySelector('input:checked'); return i ? i.value : null; }); }
  function fixCombo(changedIndex) {
    loadVariants().then(function (vs) {
      var sel = current();
      if (!vs.length || sel.indexOf(null) >= 0) return;
      var exists = vs.some(function (v) { return v.options.every(function (o, k) { return o === sel[k]; }); });
      if (exists) return;
      var cands = vs.filter(function (v) { return v.options[changedIndex] === sel[changedIndex] && v.available; });
      if (!cands.length) cands = vs.filter(function (v) { return v.options[changedIndex] === sel[changedIndex]; });
      if (!cands.length) return;
      cands.sort(function (a, b) {
        var sa = a.options.filter(function (o, k) { return o === sel[k]; }).length, sb = b.options.filter(function (o, k) { return o === sel[k]; }).length;
        return sb - sa;
      });
      var target = cands[0];
      fieldsets().forEach(function (fs, k) {
        if (k === changedIndex || target.options[k] === sel[k]) return;
        var inp = Array.prototype.slice.call(fs.querySelectorAll('input')).filter(function (i) { return i.value === target.options[k]; })[0];
        if (inp) inp.click();
      });
    });
  }

  /* 5. Bloc d'avis vide (0 avis) : masque tant qu'aucun avis n'existe, les etoiles restent sous le titre */
  function hideEmptyReviews() {
    document.querySelectorAll('.shopify-section').forEach(function (sec) {
      if (!sec.querySelector('[class*="AirReviews"]') || sec.closest('.product__info-container')) return;
      if (sec.querySelector('.product__info-container')) return;
      var t = sec.innerText || '';
      if ((/(^|[^0-9])0\s+reviews?/i.test(t) || /No reviews/i.test(t)) && /Reviews/.test(t)) sec.classList.add('bc-reviews-empty');
    });
  }
  function bindCombo() {
  document.addEventListener('change', function (e) {
    var fs = e.target && e.target.closest && e.target.closest('variant-selects fieldset, variant-radios fieldset');
    if (!fs) return;
    var idx = fieldsets().indexOf(fs);
    if (fieldsets().length > 1 && idx >= 0) setTimeout(function () { fixCombo(idx); }, 30);
  });
  }
})();
